---
import Hero from "./Containers/Hero.svelte";
import Countdown from "./Countdown/Countdown.svelte";
import ImageTitle from "./Image/ImageTitle.svelte";
import HeroTitle from "./Text/HeroTitle.svelte";
import Text from "./Text/Text.svelte";
import MediaSlider from "@components/blocks/Sliders/MediaSlider.svelte";
import Actions from "@components/blocks/Buttons/Actions.svelte";
import HeroSlider from "@components/blocks/Sliders/HeroSlider.svelte";
import SubscribeForm from "./Forms/SubscribeFormWrapper.astro";
import VideoEmbed from "@components/content/VideoEmbed.svelte";
import HeaderBlock from "@components/blocks/Header/HeaderBlock.svelte";
import ContainerBlock from "@components/blocks/Containers/ContainerBlock.svelte";
import ColumnsBlock from "./Containers/ColumnsBlock.svelte";
import BentoBlock from "./Containers/BentoBlock.svelte";
import StyledTextBlock from "./Text/StyledTextBlock.svelte";
import DividerBlock from "./Misc/DividerBlock.svelte";
import VideoBlock from "./Misc/VideoBlock.svelte";
import CodeBlock from "./Misc/CodeBlock.svelte";
import TestimonialsBlock from "./Misc/TestimonialsBlock.svelte";

interface Props {
  block: any;
}
const { block } = Astro.props;
---

<!-- this will need to be client:only="svelte" to accomodate Actions block when we have more than one hero on a page -->{
  block.type === "hero" && <Hero {...block} client:visible />
}
{block.type === "hero_title" && <HeroTitle {...block} />}
{block.type === "image_title" && <ImageTitle {...block} />}
{block.type === "text" && <Text {...block} />}
{block.type === "countdown" && <Countdown {...block} />}
{
  block.type === "media_slider" && (
    <MediaSlider {...block} client:only="svelte" />
  )
}
{block.type === "video_embed" && <VideoEmbed {...block} client:visible />}
{block.type === "actions" && <Actions {...block} client:only="svelte" />}
{block.type === "hero_slider" && <HeroSlider {...block} client:visible />}
{block.type === "subscribe_form" && <SubscribeForm {...block} />}
{block.type === "header" && <HeaderBlock {...block} />}
{block.type === "container" && <ContainerBlock {...block} />}
{block.type === "columns_block" && <ColumnsBlock {...block} />}
{block.type === "bento_block" && <BentoBlock {...block} client:only="svelte" />}
{block.type === "styled_text" && <StyledTextBlock {...block} />}
{block.type === "divider_block" && <DividerBlock {...block} />}
{block.type === "video_block" && <VideoBlock {...block} client:only="svelte" />}
{block.type === "code_block" && <CodeBlock {...block} />}
{
  block.type === "testimonials_block" && (
    <TestimonialsBlock {...block} client:only="svelte" />
  )
}
